import { endpoints } from 'Constants';
const locationServices = {
	getLocationsList: (params) => ({
		baseURL: endpoints.LOCATION.LIST(params),
		method: 'GET',
	}),

	getNeshanPosition: (params) => ({
		baseURL: endpoints.LOCATION.NESHAN_POSITION(params),
		method: 'GET',
		'Api-Key': 'service.WX0v4jsiQEve0wqP5a0uUYfeYnIwXFS0TA6bvPEm',
	}),

	pointToAddress: (params) => ({
		baseURL: endpoints.LOCATION.POINT_TO_ADDRESS(),
		method: 'POST',
		data: params,
	}),
	pointToLocation: (params) => ({
		baseURL: endpoints.LOCATION.POINT_TO_LOCATION(),
		method: 'POST',
		data: params,
	}),
	locationGeneral: (params) => ({
		baseURL: endpoints.LOCATION.LOCATION_GENERAL(),
		method: 'GET',
		params,
	}),
};

export default locationServices;
